import { render } from "./TestCamera.vue?vue&type=template&id=8fd9cfd0"
import script from "./TestCamera.vue?vue&type=script&lang=js"
export * from "./TestCamera.vue?vue&type=script&lang=js"

import "./TestCamera.vue?vue&type=style&index=0&id=8fd9cfd0&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__